/** The ToC lobby files to draw, bottom first: the file on screen stays under a new one until the new one has loaded. */
export const tocLobbyLayers = (riveUrl: string | null, shownRiveUrl: string | null): string[] => {
  if (!riveUrl) return [];
  return shownRiveUrl && shownRiveUrl !== riveUrl ? [shownRiveUrl, riveUrl] : [riveUrl];
};

/** A banner leaving (`reported: null`) clears only its own file, not the newer one that replaced it. */
export const shownTocRiveUrlAfter = ({
  shown,
  reported,
  reporter,
}: {
  shown: string | null;
  reported: string | null;
  reporter: string;
}): string | null => reported ?? (shown === reporter ? null : shown);
